import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { FormGroup, Label } from '../formInputsV2/styles/common';
import { reactSelectStyles } from '../formInputsV2/reactSelectStyles';

function FormReactSelectSimpleMulti({
  label, options, error, valid, onChange, value,
}) {
  const [prepOptions, setPrepOptions] = useState([]);
  const [currentSelected, setCurrentSelected] = useState([]);

  const handleChange = (selected) => {
    const selectedArray = selected || [];

    const selectedValues = selectedArray.map((item) => item.value);
    setCurrentSelected(selectedValues);
    onChange(selectedValues);
  };

  useEffect(() => {
    setPrepOptions(options.map((i) => ({ value: i.id, label: i.name })));
  }, [options]);

  useEffect(() => {
    setCurrentSelected(value || []);
  }, [value]);

  return (
    <FormGroup>
      <Label>{label}</Label>
      <Select
        options={prepOptions}
        isSearchable
        placeholder=""
        value={options.filter((opt) => currentSelected.includes(opt.id)).map((o) => ({ value: o.id, label: o.name }))}
        onChange={handleChange}
        isMulti
        loadingMessage={() => 'Caricando elenco...'}
        clearValue
        isClearable
        noOptionsMessage={() => 'Elenco non trovato!'}
        styles={reactSelectStyles({ error, valid })}
      />
      <div className="invalid-feedback">{error}</div>
    </FormGroup>
  );
}

export default FormReactSelectSimpleMulti;
